import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomCol from '../../../../../components/CustomCol';
// import CustomInputLink from '../../../../../components/CustomInputs/CustomInputLink';
import CustomInputText from '../../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../../components/CustomRow';
import { IMedsusDiretrizRegistro } from '../../../../../modules/types/MedsusNew';
// import { useGrupoFinanciamento } from '../../../../../services/enum/useGrupoFinanciamento';
// import { useComponenteAFOnco } from '../../../../../services/medsus/useComponenteAFOnco';
// import { useResponsavelDiretriz } from '../../../../../services/medsus/useResponsavelDiretriz';
// import { useStatusDiretriz } from '../../../../../services/medsus/useStatusDiretriz';
// import { useTipoDiretriz } from '../../../../../services/medsus/useTipoDiretriz';

interface DiretrizDetailBoxProps {
  isCollapsed?: boolean;
  medsusDiretrizRegistro: IMedsusDiretrizRegistro | undefined;
}

export function DiretrizDetailBox({
  isCollapsed,
  medsusDiretrizRegistro,
}: DiretrizDetailBoxProps) {
  // Enums
  // const componenteAFOnco = useComponenteAFOnco();
  // const tipoDiretriz = useTipoDiretriz();
  // const statusDiretriz = useStatusDiretriz();
  // const responsavelDiretriz = useResponsavelDiretriz();
  // const grupoFinanciamento = useGrupoFinanciamento();

  return (
    <>
      {medsusDiretrizRegistro?.diretrizesVmp.map((diretrizVmp, index) => (
        // <BoxConteudo
        //   boxTitulo={`Registro ${index + 1}`}
        //   key={diretrizVmp.id}
        //   style={{ marginBottom: '8px' }}
        // >
        <div>
          <BoxConteudo
            boxTitulo={`Medicamento ${index + 1}`}
            key={diretrizVmp.vmp.id}
            style={{ marginBottom: '8px' }}
            fechado={isCollapsed ?? false}
          >
            <CustomRow>
              <CustomCol width="20%">
                <CustomInputText
                  title="Código OBM"
                  value={diretrizVmp?.vmp.obm ?? 'N/A'}
                  readOnly
                  name="obm"
                />
              </CustomCol>
              <CustomCol>
                <CustomInputText
                  title="Nome do Medicamento"
                  value={diretrizVmp?.vmp.nome ?? 'N/A'}
                  readOnly
                  name="nome"
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </div>

        //   <div className="my-2">
        //     <BoxConteudo
        //       boxTitulo={`Diretriz Clínica`}
        //       key={diretrizVmp.diretriz.id}
        //       fechado={isCollapsed}
        //       style={{ marginBottom: '8px' }}
        //     >
        //       <CustomRow
        //         key={diretrizVmp.diretriz.id}
        //         style={{ marginBottom: '1rem' }}
        //       >
        //         <CustomCol>
        //           <CustomInputText
        //             title="Nome"
        //             value={diretrizVmp.diretriz.nome ?? 'N/A'}
        //             readOnly
        //             name={`diretriz_nome_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //       </CustomRow>
        //       <CustomRow>
        //         <CustomCol width="25%">
        //           <CustomInputText
        //             title="Responsabilidade Aquisição"
        //             value={
        //               responsavelDiretriz[
        //                 Number(diretrizVmp.diretriz.respAquisicao)
        //               ]?.label ?? ''
        //             }
        //             readOnly
        //             name={`diretriz_resp_aquisicao_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="25%">
        //           <CustomInputText
        //             title="Responsabilidade Financiamento"
        //             value={
        //               responsavelDiretriz[
        //                 Number(diretrizVmp.diretriz.respFinanciamento)
        //               ]?.label ?? ''
        //             }
        //             readOnly
        //             name={`diretriz_resp_financiamento_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol>
        //           <CustomInputText
        //             title="Abrangência"
        //             value={diretrizVmp.diretriz.abrangencia.toString() ?? 'N/A'}
        //             readOnly
        //             name={`diretriz_abrangencia_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //       </CustomRow>
        //       <CustomRow style={{ justifyContent: 'flex-start' }}>
        //         <CustomCol width="15%">
        //           <CustomInputText
        //             title="Status"
        //             value={
        //               statusDiretriz[Number(diretrizVmp.diretriz.status)]
        //                 ?.label ?? ''
        //             }
        //             readOnly
        //             name={`diretriz_status_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="17%">
        //           <CustomInputText
        //             title="Tipo"
        //             value={
        //               tipoDiretriz[Number(diretrizVmp.diretriz.tipo)]?.label ??
        //               ''
        //             }
        //             readOnly
        //             name={`diretriz_tipo_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="15%">
        //           <CustomInputText
        //             title="Componente AF"
        //             value={
        //               componenteAFOnco[
        //                 Number(diretrizVmp.diretriz.componenteAF)
        //               ]?.label ?? ''
        //             }
        //             readOnly
        //             name={`diretriz_componente_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="15%">
        //           <CustomInputText
        //             title="Grupo Financiamento"
        //             value={
        //               grupoFinanciamento[
        //                 Number(diretrizVmp.diretriz.grupoFinanciamento)
        //               ]?.label ?? ''
        //             }
        //             readOnly
        //             name={`diretriz_grupo_financiamento_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="19%">
        //           <CustomInputText
        //             title="Qtd. Docs/Exames"
        //             value={
        //               diretrizVmp.diretriz.documentos
        //                 ? diretrizVmp.diretriz.documentos.length.toString()
        //                 : '0'
        //             }
        //             readOnly
        //             name={`diretriz_documentos_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //         <CustomCol width="19%">
        //           <CustomInputText
        //             title="Qtd. Critérios"
        //             value={
        //               diretrizVmp.diretriz.criterios
        //                 ? diretrizVmp.diretriz.criterios.length.toString()
        //                 : '0'
        //             }
        //             readOnly
        //             name={`diretriz_criterios_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //       </CustomRow>
        //       <CustomRow>
        //         <CustomCol>
        //           <CustomInputText
        //             title="CID-10 Associados"
        //             value={
        //               diretrizVmp.diretriz.cids &&
        //               diretrizVmp.diretriz.cids.length > 0
        //                 ? diretrizVmp.diretriz.cids
        //                     .map((cid) => `${cid.cid?.cid ?? ''}`)
        //                     .join('; ')
        //                 : 'N/A'
        //             }
        //             readOnly
        //             name={`diretriz_cids_${diretrizVmp.diretriz.id}`}
        //           />
        //         </CustomCol>
        //       </CustomRow>

        //       <CustomRow>
        //         <CustomCol>
        //           <CustomInputLink
        //             name={`diretriz_link_cidadao_${diretrizVmp.diretriz.id}`}
        //             readOnly
        //             title="Orientações para o Cidadão"
        //             value={diretrizVmp.diretriz.linkCidadao ?? ''}
        //           />
        //         </CustomCol>
        //         <CustomCol>
        //           <CustomInputLink
        //             name={`diretriz_link_farmaceut_${diretrizVmp.diretriz.id}`}
        //             readOnly
        //             title="Orientações para o Farmacêutico"
        //             value={diretrizVmp.diretriz.linkFarmaceutico ?? ''}
        //           />
        //         </CustomCol>
        //       </CustomRow>
        //     </BoxConteudo>
        //   </div>
        // </BoxConteudo>
      ))}
    </>
  );
}
